module.exports = __webpack_public_path__ + "img/홀덤아이콘.411bfb0b.jpg";